import { FC } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormControl, Stack, TextField } from '@mui/material';

type TFormProps = Pick<
  UseFormReturn<{ link: string; name: string }>,
  'formState' | 'register'
> & {
  onSubmit: () => void;
};

const AddCustomToolForm: FC<TFormProps> = ({
  formState,
  register,
  onSubmit,
}) => {
  const { errors } = formState;
  return (
    <FormControl component="form" fullWidth onSubmit={onSubmit}>
      <Stack spacing={1} direction="column">
        <TextField
          autoFocus
          label="Name"
          variant="standard"
          error={!!errors.name}
          helperText={errors.name && errors.name.message}
          required
          {...register('name')}
        />
        <TextField
          label="Link"
          variant="standard"
          error={!!errors.link}
          helperText={errors.link && errors.link.message}
          required
          {...register('link')}
        />
      </Stack>
    </FormControl>
  );
};

export default AddCustomToolForm;
